import { render } from "./DocumentClassTableColumns.vue?vue&type=template&id=685ea9bc&scoped=true&ts=true"
import script from "./DocumentClassTableColumns.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTableColumns.vue?vue&type=script&lang=ts"

import "./DocumentClassTableColumns.vue?vue&type=style&index=0&id=685ea9bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685ea9bc"]])

export default __exports__